import $ from './el.JsModules.js';

const SELECTOR = {
  TEMPLATE: '#template-currency-selector',
  TRIGGER: '.js-currency-selector-trigger',
  OVERLAY: '.js-overlay',
  CONTAINER: '.js-el-currency-selector',
  CLOSE_BTN: '.js-close-button',
  POPULAR_LIST: '.js-popular-countries',
  SEPARATOR: '.js-separator',
  LINK_WRAPPER: '[data-name]',
  DYNAMIC_LINK_WRAPPER: (value) => `.js-all-countries [data-name^="${value}"]`,
  LINK: '.js-link',
  SEARCH_INPUT: '.js-search-input',
};

elabs.CurrencySelector = class {
  'use strict';

  constructor(element) {
    this.q = '';
    this.view = $(element);
    this.templateElement = this.view.find(SELECTOR.TEMPLATE)[0];
    this.initialized = false;

    this.triggerBtn = $(SELECTOR.TRIGGER);
    this.triggerBtn.on('click', () => this.show());
  }

  show() {
    if (!this.initialized) {
      this.view.append($(this.templateElement.content.cloneNode(true)));

      this.overlay = this.view.find(SELECTOR.OVERLAY);
      this.container = this.view.find(SELECTOR.CONTAINER);
      this.closeBtn = this.view.find(SELECTOR.CLOSE_BTN);
      this.searchInput = this.view.find(SELECTOR.SEARCH_INPUT);
      this.popularList = this.view.find(SELECTOR.POPULAR_LIST);
      this.separator = this.view.find(SELECTOR.SEPARATOR);
      this.allLinks = this.view.find(SELECTOR.LINK_WRAPPER);
      this.links = this.view.find(SELECTOR.LINK);

      this.overlay.on('click', () => this.hide());
      this.closeBtn.on('click', () => this.hide());

      this.searchInput.on('input', (e) => {
        const val = $(e.target).val().toLowerCase();
        if (val.length > 0) {
          const targetSelector = SELECTOR.DYNAMIC_LINK_WRAPPER(val);
          this.popularList.hide();
          this.separator.hide();
          this.allLinks.hide();
          this.view.find(targetSelector).show();
          return;
        }
        this.allLinks.show();
        this.separator.show();
        this.popularList.show();
      });

      this.links.each(function () {
        $(this).on('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          const form = $(this).closest('form');
          const countryInput = form.find('[name="country_code"]');
          const isoCode = $(this).data('value');
          countryInput.val(isoCode);
          form.trigger('submit');
        });
      });

      this.initialized = true;
    }

    setTimeout(() => {
      this.view.addClass('active');
      this.container.addClass('el-currency-selector--visible');
      this.toggleBodyClasses();
    }, 50);
  }

  hide() {
    this.view.removeClass('active');
    this.container.removeClass('el-currency-selector--visible');
    this.container.addClass('el-currency-selector--dismissed');
    this.toggleBodyClasses();
    setTimeout(() => {
      this.container.removeClass('el-currency-selector--dismissed');
    }, 100);
  }

  toggleBodyClasses() {
    $('body').toggleClass('overflow-hidden blur-content');
  }
};

elabs.onJavascriptReady(function () {
  new elabs.CurrencySelector($('#CurrencySelector'));
});
